// extracted by css-extract-rspack-plugin
export default {"root":"root-IEAq5x","split":"split-OMiXA2","content":"content-EPG2L0","side":"side-IxtIDi","dragAndDropOverlay":"dragAndDropOverlay-OUMc_n"};